import axios from "axios";
import { AXIOS_CONFIG } from "../../../utils/api";
import { backend_url } from "../../../constants";

/**
 * Sends client invitations via API.
 * @param emails Array of email addresses to invite
 * @param message Optional custom message to include in the invitation
 * @returns The API response if successful
 * @throws Error if the request fails
 */
export const sendClientInvitations = async (
  emails: string[],
  message: string = ""
) => {
  try {
    const response = await axios.post(
      `${backend_url}/api/invite/clients/`,
      {
        emails,
        message,
      },
      AXIOS_CONFIG
    );
    return response;
  } catch (error) {
    console.error("Error sending client invitations:", error);
    // Optionally, you can add more error handling here
    throw error;
  }
};
